import useTranslation from "next-translate/useTranslation";
import React, { memo } from "react";
import { FiCheckCircle } from "react-icons/fi";
import Widget from "shared/components/templates/Widget/index";
import staticIntlTranslatorToString from "shared/utils/staticIntlTranslatorToString";
import { Container } from "./styles";




const Resourcers = ({ course }) => {
  const features = course && course.features;
  const { t, lang } = useTranslation();

  return (
    <>
      {features?.length > 0 && (
        <Container>
          <Widget
            transparentDarkDisabled
            styleName="gx-card-tabs gx-card-tabs-right gx-card-profile"
            title={t("common:resourcers")}
          >
            <ul>
              {features?.map((feature) => (
                <li key={feature?.id}>
                  <div className="icon-container">
                    <FiCheckCircle size={17} />
                  </div>
                  {staticIntlTranslatorToString(feature?.name, lang)}
                </li>
              ))}
            </ul>
          </Widget>
        </Container>
      )}
    </>
  );
};

export default memo(Resourcers);
